<template>
<div>
    <div class="btn-wrapper">
      <div class="btn-rules entrance show-enter-active" @click="onClickRules">规则</div>
      <!-- 已报名才展示 -->
      <div class="btn-requirement entrance" @click="onClickRequirement" v-show="isApplyStaus">命题</div>
       <div class="btn-pass-wrapper" @click="onClickPast" v-show="isShowPast">
        <div class="btn-pass">往期进度</div>
      </div>
    </div>
    <writing-requirement ref="writingRequirement" :topicInfo="topicInfo" v-show="isShowRequirement"/>
</div>

</template>
<script>
import WritingRequirement from '../common/writingRequirement'
import { Dialog } from 'vant'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'topButtons',
  props: {
    activityInfo: {
      type: Object,
      required: true
    },
    topicInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
    WritingRequirement
  },
  mounted() {
    this.showPastTip()
  },
  computed: {
    ...mapState(['myUserId']),
    // 已提交才展示
    isApplyStaus() {
      const { apply_status, submit_status } = this.activityInfo
      return +apply_status === 1 && +submit_status !== 0
    },
    isShowPast() {
      return +this.activityInfo.artical_num > 0
    },
    isShowRequirement() {
      return +this.activityInfo.apply_status === 1
    }
  },
  methods: {
    onClickRules() {
      this.$xesLogger.clickMsg({
        params: { clickid: '10.0.4', elemname: '点击查看活动规则' }
      })
      this.$router.push({
        name: 'activityrules'
      })
    },
    onClickRequirement() {
      this.$xesLogger.clickMsg({
        params: { clickid: '10.0.5', elemname: '点击写作要求' }
      })
      this.$refs.writingRequirement.visible = true
    },
    onClickPast() {
      this.$xesLogger.clickMsg({
        params: { clickid: '10.0.6', elemname: '点击往期征文入口' }
      })
      this.$router.push({
        name: 'personalList'
      })
    },
    showPastTip() {
      const key = `${this.myUserId}_summerCampArticalNum`
      if (+this.activityInfo.artical_num >= 2 && !localStorage.getItem(key)) {
        Dialog.alert({
          title: '温馨提示',
          message: '往期征文评审进度更新啦\n请移步【往期进度】查看！',
          theme: 'round-button',
          confirmButtonText: '我知道啦'
        })
        localStorage.setItem(key, 1)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.show-enter-active,
.show-leave-active {
  transition: all 1s;
}

.btn-wrapper {
  position: fixed;
  top: 6%;
  right: 0;
  z-index: 2;

  .entrance {
    width: 36px;
    height: 21px;
    font-size: 11px;
    font-weight: 250;
    line-height: 21px;
    text-align: center;
    color: #fff;
    background: linear-gradient(331deg, #3ca869 0%, #44ac6f 20%, #71c28e 100%);
    border: 1px solid #fff;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-right: none;
  }

  .btn-pass-wrapper {
    margin-top: 13px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid #fff;
    border-right: none;
  }

  .btn-pass {
    position: relative;
    right: -6px;
    width: 31px;
    height: auto;
    padding-right: 6px;
    font-size: 11px;
    font-weight: 500;
    line-height: 15px;
    line-height: 14px;
    text-align: center;
    color: #fff;
  }

  .entrance:not(:first-child) {
    margin-top: 13px;
  }
}
</style>
